module.exports = __webpack_public_path__ + "0d938135f4b5a00a4beb3d1db5d1cead.svg";